<div class="w-screen h-screen bg-primary text-white leading-7" *ngIf="isMobile || (!isLandscape && isTablet); else landscape">
  <div class="text-center m-auto px-7 text-2xl font-normal leading-10" *ngIf="isMobile">
    <svg-icon key="logo-onmat-white" size="xxl" class="logo-landscape mt-6 mb-10"></svg-icon>
    <p class="mb-10" translate>
      f.landscape.generic <strong><span translate>f.landscape.mobile</span></strong>
    </p>
    <img class="m-auto" src="../assets/img/mobile_ONMAT.png" alt="Mobile Onmat" />
    <a class="w-full underline mt-10 block pb-12" (click)="loadAnyway()"><span translate>f.landscape.button</span></a>
  </div>
  <div class="text-center m-auto px-7 text-3xl font-bold" *ngIf="!isLandscape && isTablet">
    <svg-icon key="logo-onmat-white" class="logo-landscape mt-6 mb-10"></svg-icon>
    <p class="mb-10" translate>f.landscape.tablet</p>
    <img src="../assets/img/tablet_ONMAT.gif" alt="Tablet Onmat" />
    <a class="w-full underline mt-10 block pb-12" (click)="loadAnyway()"><span translate>f.landscape.button</span></a>
  </div>
</div>
<ng-template #landscape>
  <div class="antialiased h-full">
    <zero-header *ngIf="showHeader"></zero-header>
    <main class="h-full mt-16">
      <router-outlet></router-outlet>
    </main>
  </div>
</ng-template>
